export default __webpack_public_path__ + "media/landscape/logo_saintlaurent-2ac023c8.svg";